import { EmptyState } from '@shopify/polaris';
import React from 'react';
import { Box } from '@shopify/polaris';

const InitPageContent = ({isTracking})=> {
    
    return (
        <Box className="management_no_product_container">
            <EmptyState
                  heading=""
                  image={isTracking ?"/product_management/init_sai_page.png" : "/product_management/init_page.png"}
                >
                 <Box className="management_no_product">
                    <Box className="management_no_product_text"><p>{isTracking ? "No trackable order": "There are currently no orders"}</p></Box>
                 </Box> 
                </EmptyState>
        </Box>
    );
}

export default InitPageContent;
